import { LOGO_URL } from "@/lib/api";

export const Logo = ({ size = 36, className = "", showText = true, variant = "default" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <img
      src={LOGO_URL}
      alt="CEAP BRASIL"
      style={{
        height: size,
        width: "auto",
        // For white variant, invert colors (logo has dark navy + black text on transparent BG)
        filter: variant === "white" ? "brightness(0) invert(1)" : undefined,
      }}
      className="object-contain"
      data-testid="app-logo"
    />
    {showText && (
      <div className="flex flex-col leading-tight">
        <span
          className={
            "font-display font-semibold text-[15px] tracking-tight " +
            (variant === "white" ? "text-white" : "text-[hsl(var(--primary))]")
          }
        >
          CEAP BRASIL
        </span>
        <span
          className={
            "text-[10px] uppercase tracking-wider " +
            (variant === "white" ? "text-white/70" : "text-muted-foreground")
          }
        >
          Plataforma do Aluno
        </span>
      </div>
    )}
  </div>
);
